export const emailRegexp = /\S+@\S+\.\S+/;

export function getRequiredFieldMessage(t, label) {
  return t('formValidation.requiredField', '{{label}} is required', {
    label: label,
  });
}
